<template>
    <div class="pages p20">
        <div class="title-btn-block">
            <div class="title-block">{{ $t("message.my_advance_requests") }}</div>
            <div>
              <router-link  :to="{ name: 'advances'}">
                  <div class="my-btn mr-2 el-button" style="background:#00CC00; color:#fff; margin-right: 10px;">
                      Создать
                  </div>
              </router-link>
                <router-link :to="{ name: 'Home' }">
                    <div class="my-btn cr1 el-button">
                        <i class="el-icon-d-arrow-left"></i> {{$t('message.back')}}
                    </div>
                </router-link>
            </div>
        </div>

        <div class="content-block">
            <div class="datetime-end bg p20 mb20">
                <el-divider content-position="left"> {{ $t("message.my_advance_requests") }} </el-divider>
                <div class="scrol-table crmhome__scroll my-table">
                  <table >
                        <thead>
                            <tr>
                               <th>{{ $t("message.user") }}</th>
                                <th>{{ $t("message.advance_amount") }}</th>
                                <th>{{ $t("message.request_data") }}</th>
                                <th>{{ $t("message.status") }}</th>
                                <th>{{ $t("message.comment") }}</th>
                                <th>{{ $t("message.created_at") }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="salary in lists" :key="salary.id">
                                <td>{{salary.staff.name}} {{salary.staff.last_name}} {{salary.staff.middle_name}}</td>
                                <!-- <td>{{salary.reason.name}}</td> -->
                                <!-- <td>{{salary.left_date}} {{salary.left_time}}</td> -->
                                <!-- <td>{{salary.coming_date}} {{salary.coming_time}}</td> -->
                                <td>{{salary.amount}}</td>
                                <td v-if="salary.periot == 'today'" >{{'Bugunga'}}</td>                                
                                <td v-if="salary.periot == 'tomorrow'" >{{'Ertaga'}}</td>                                
                                <td v-if="salary.periot == 'this_week'" >{{'Shu haftaga'}}</td>                                
                                <td v-if="salary.status == 'accept'" style="background: #00a838">{{$t('message.received')}}</td>
                                <td v-if="salary.status == 'waiting'" style="background: #E6A23C">{{ $t("message.waiting") }}</td>
                                <td>{{salary.comment}}</td>
                                <th>{{ salary.created_at }}</th>

                            </tr>
                           
                        </tbody>
                    </table>
                </div>
            </div>
             
        </div>
    </div>
</template>
<script>
import { getItem } from "@/utils/storage";

import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      salarys:null,
      complaints:[],
      advance_salary:null
    };
  },
  mounted() {
    this.getTable()
  },
  computed:{
    ...mapGetters({
      lists:"advance/list",
    })
  },
  methods: {
    ...mapActions({
      updateList: "advance/index",
    }),

    getTable() {
      this.updateList(getItem("userId"))
        .then((res) => {
          this.assents = res.take_assent
          this.vacations = res.vacation
          this.advance_salary = res.advance_salary
        })
        .catch((err) => {
          this.$alert(err);
        });
    },
  },
};
</script>
